import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconDownload = createIcon({
  displayName: 'IconDownload',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M13 10.76L12 11.76L11 10.76V2H13V10.76ZM12 17.41L5.29 10.71L6.71 9.29L12 14.59L17.29 9.29L18.71 10.71L12 17.41ZM20 21V19H4V21H20Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
